module.exports = __webpack_public_path__ + "media/images/emblems/Paradiso-coat_of_arms-53e6cbffcf4f8039379a329b0968e71b.svg";